// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lGmq","right":"styles_right__3nTqd"};